import { render } from "./addmarketing.vue?vue&type=template&id=e4147bee"
import script from "./addmarketing.vue?vue&type=script&lang=js"
export * from "./addmarketing.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__